import {
  WiNightClear,
  WiDaySunny,
  WiNightAltCloudy,
  WiDayCloudy,
  WiCloud,
  WiFog,
  WiNightAltShowers,
  WiDayShowers,
  WiNightAltSnow,
  WiDaySnow,
  WiNightAltSleet,
  WiDaySleet,
  WiSnow,
  WiNightAltLightning,
  WiDayLightning,
  WiSnowWind,
  WiRain,
  WiShowers,
  WiNightAltRain,
  WiDayRain,
  WiSleet,
  WiNightAltSnowWind,
  WiDaySnowWind,
  WiLightning,
  WiNightAltStormShowers,
  WiDayStormShowers,
  WiStormShowers,
} from "react-icons/wi";

export const getWeatherIcon = (code, isDay) => {
  const icons = {
    1000: [<WiNightClear />, <WiDaySunny />],
    1003: [<WiNightAltCloudy />, <WiDayCloudy />],
    1006: [<WiCloud />, <WiCloud />],
    1009: [<WiCloud />, <WiCloud />],
    1030: [<WiFog />, <WiFog />],
    1063: [<WiNightAltShowers />, <WiDayShowers />],
    1066: [<WiNightAltSnow />, <WiDaySnow />],
    1069: [<WiNightAltSleet />, <WiDaySleet />],
    1072: [<WiSnow />, <WiSnow />],
    1087: [<WiNightAltLightning />, <WiDayLightning />],
    1114: [<WiSnow />, <WiSnow />],
    1117: [<WiSnowWind />, <WiSnowWind />],
    1135: [<WiFog />, <WiFog />],
    1147: [<WiFog />, <WiFog />],
    1150: [<WiRain />, <WiRain />],
    1153: [<WiRain />, <WiRain />],
    1168: [<WiSnow />, <WiSnow />],
    1171: [<WiSnow />, <WiSnow />],
    1180: [<WiNightAltShowers />, <WiDayShowers />],
    1183: [<WiShowers />, <WiShowers />],
    1186: [<WiNightAltShowers />, <WiDayShowers />],
    1189: [<WiShowers />, <WiShowers />],
    1192: [<WiNightAltRain />, <WiDayRain />],
    1195: [<WiRain />, <WiRain />],
    1198: [<WiSnow />, <WiSnow />],
    1201: [<WiSnow />, <WiSnow />],
    1204: [<WiSleet />, <WiSleet />],
    1207: [<WiSleet />, <WiSleet />],
    1210: [<WiNightAltSnow />, <WiDaySnow />],
    1213: [<WiSnow />, <WiSnow />],
    1216: [<WiNightAltSnow />, <WiDaySnow />],
    1219: [<WiSnow />, <WiSnow />],
    1222: [<WiNightAltSnowWind />, <WiDaySnowWind />],
    1225: [<WiSnowWind />, <WiSnowWind />],
    1237: [<WiSnowWind />, <WiSnowWind />],
    1240: [<WiNightAltShowers />, <WiDayShowers />],
    1243: [<WiNightAltRain />, <WiDayRain />],
    1246: [<WiNightAltRain />, <WiDayRain />],
    1249: [<WiNightAltSleet />, <WiDaySleet />],
    1252: [<WiNightAltSleet />, <WiDaySleet />],
    1255: [<WiNightAltSnow />, <WiDaySnow />],
    1258: [<WiNightAltSnowWind />, <WiDaySnowWind />],
    1261: [<WiNightAltSnow />, <WiDaySnow />],
    1264: [<WiNightAltSnowWind />, <WiDaySnowWind />],
    1273: [<WiNightAltLightning />, <WiDayLightning />],
    1276: [<WiLightning />, <WiLightning />],
    1279: [<WiNightAltStormShowers />, <WiDayStormShowers />],
    1282: [<WiStormShowers />, <WiStormShowers />],
  };

  return icons[code][isDay];
};
